import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';

export default function ContactForm({ provider, isOpen, onClose }) {
  const user = useSelector((state) => state.auth.user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add your form submission logic here
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={onClose}
              className="fixed inset-0 bg-black/80 backdrop-blur-sm"
            />

            {/* Modal */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              className="relative transform overflow-hidden rounded-2xl bg-[#1a1f2e] 
                        border border-white/10 shadow-xl transition-all
                        w-full max-w-lg my-8 text-left"
            >
              <div className="max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                  {/* Close Button */}
                  <button
                    onClick={onClose}
                    className="absolute right-4 top-4 rounded-full p-1
                              bg-white/10 hover:bg-white/20 transition-colors"
                  >
                    <XMarkIcon className="h-5 w-5 text-gray-400" />
                  </button>

                  {/* Header */}
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-white">
                      Contact {provider.name}
                    </h3>
                    <p className="mt-1 text-sm text-gray-400">
                      Fill out the form below and we'll get back to you as soon as possible.
                    </p>
                  </div>

                  {/* Form */}
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-1.5">
                        Full Name
                      </label>
                      <input
                        type="text"
                        defaultValue={user?.name || ''}
                        className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2.5
                                 text-white placeholder:text-gray-500 focus:border-yellow-400/50
                                 focus:ring-1 focus:ring-yellow-400/50 focus:outline-none
                                 transition-colors"
                        placeholder="Your name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-1.5">
                        Email Address
                      </label>
                      <input
                        type="email"
                        defaultValue={user?.email || ''}
                        className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2.5
                                 text-white placeholder:text-gray-500 focus:border-yellow-400/50
                                 focus:ring-1 focus:ring-yellow-400/50 focus:outline-none
                                 transition-colors"
                        placeholder="your@email.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-1.5">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2.5
                                 text-white placeholder:text-gray-500 focus:border-yellow-400/50
                                 focus:ring-1 focus:ring-yellow-400/50 focus:outline-none
                                 transition-colors"
                        placeholder="+44 123 456 7890"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-1.5">
                        Message
                      </label>
                      <textarea
                        rows={4}
                        className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2.5
                                 text-white placeholder:text-gray-500 focus:border-yellow-400/50
                                 focus:ring-1 focus:ring-yellow-400/50 focus:outline-none
                                 transition-colors resize-none"
                        placeholder="Write your message here..."
                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3 pt-4">
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        type="submit"
                        className="flex-1 px-6 py-2.5 rounded-xl font-medium text-sm
                                 bg-gradient-to-r from-yellow-400 to-green-400
                                 text-gray-900 hover:shadow-lg hover:from-yellow-300 
                                 hover:to-green-300 transition-all duration-200"
                      >
                        Send Message
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        type="button"
                        onClick={onClose}
                        className="px-6 py-2.5 rounded-xl font-medium text-sm
                                 bg-white/10 text-white hover:bg-white/20
                                 transition-all duration-200"
                      >
                        Cancel
                      </motion.button>
                    </div>
                  </form>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
}
